export default __webpack_public_path__ + "static/media/icon-location.894bd4e0.svg";